import { ele } from "cables-shared-client";
import web from "../../index.js";
import api from "../../api.js";

export default class PageMyData
{
    constructor(targetElement)
    {
        this._files = null;

        const tabs = targetElement.querySelectorAll("ul.tab-bar li");
        tabs.forEach((tab) =>
        {
            tab.addEventListener("activated", (e) =>
            {
                if (e.detail && e.detail.fromUserInteraction)
                {
                    window.history.replaceState(null, "", window.location.pathname + window.location.hash);
                }
            });
        });
    }

    getPatchStorageTable(targetElement)
    {
        let url = new URL(window.location.href);
        let limit = url.searchParams.get("pl") || 20;
        let offset = url.searchParams.get("po") || 0;

        const apiUrl = web.tabs.addPagination("mydata/patchassets", limit, offset);
        api.get(apiUrl, (res) =>
        {
            if (res && res.data)
            {
                web.setHandleBarHtml("settings_mydata_patches", { "patches": res.data }, targetElement);
                web.tabs.initPagination(targetElement, res.pagination, limit, offset, (newLimit, newOffset) =>
                {
                    let newSearch = "";
                    if (newLimit || newLimit === 0)
                    {
                        newSearch += "?pl=" + newLimit;
                    }
                    if (newOffset)
                    {
                        newSearch += "&po=" + newOffset;
                    }
                    window.location = location.origin + location.pathname + newSearch + window.location.hash;
                });
            }
        });
    }

    getAssetStorageTable(targetElement)
    {
        let url = new URL(window.location.href);
        let limit = url.searchParams.get("al") || 20;
        let offset = url.searchParams.get("ao") || 0;

        const apiUrl = web.tabs.addPagination("mydata/assets", limit, offset);
        api.get(apiUrl, (res) =>
        {
            if (res && res.data)
            {
                web.setHandleBarHtml("settings_mydata_assets", { "assets": res.data }, targetElement);
                web.tabs.initPagination(targetElement, res.pagination, limit, offset, (newLimit, newOffset) =>
                {
                    let newSearch = "";
                    if (newLimit || newLimit === 0)
                    {
                        newSearch += "?al=" + newLimit;
                    }
                    if (newOffset)
                    {
                        newSearch += "&ao=" + newOffset;
                    }
                    window.location = location.origin + location.pathname + newSearch + window.location.hash;
                });
            }
        });
    }

    getMyOpsTable(targetElement)
    {
        api.get("mydata/ops", (res) =>
        {
            if (res && res.data)
            {
                const patchesTable = web.getHandleBarHtml("settings_mydata_ops_table", { "ops": res.data.patches });
                const usersTable = web.getHandleBarHtml("settings_mydata_ops_table", { "ops": res.data.users });
                const teamsTable = web.getHandleBarHtml("settings_mydata_ops_table", { "ops": res.data.teams });
                const extensionsTable = web.getHandleBarHtml("settings_mydata_ops_table", { "ops": res.data.extensions });
                const baseTable = web.getHandleBarHtml("settings_mydata_ops_table", { "ops": res.data.base });
                web.setHandleBarHtml("settings_mydata_ops", { "ops": res.data, patchesTable, usersTable, teamsTable, extensionsTable, baseTable }, targetElement);
                web.tabs.initTabs(targetElement.querySelectorAll("ul.tab-bar li"));
            }
        });
    }

    getBackupsTable(targetElement)
    {
        web.projects.getBackupsTable("mydata/backups", targetElement, true);
    }

    importZip()
    {
        if (this._files)
        {
            this.importProjectZip();
        }
        else
        {
            const fileElem = document.getElementById("hiddenzipElem");
            if (fileElem)
            {
                fileElem.click();
            }
        }
    }

    importProjectZip(files)
    {
        const button = ele.byId("import-zip-button");
        const resultEle = ele.byId("uploadResult");
        resultEle.classList.add("info");
        resultEle.classList.remove("error");
        resultEle.innerText = "";

        const problemsEle = ele.byId("uploadProblems");
        const filePicker = ele.byId("import-file-picker");

        ele.hide(resultEle);
        ele.hide(problemsEle);
        ele.hide(filePicker);

        let url = new URL("/api/project/import/zip", window.location.href);
        if (this._files)
        {
            files = this._files;
        }

        if (filePicker.value)
        {
            url.searchParams.append("projectFile", filePicker.value);
        }

        let formData = new FormData();
        formData.append(0, files[0]);
        let xhr = new XMLHttpRequest();
        xhr.open("POST", url);

        xhr.onload = (e) =>
        {
            button.classList.remove("button-primary");
            if (filePicker.value) filePicker.value = "";

            let res = { };
            web.buttons.stopSavingAnimButton(button, true, xhr.status !== 200);

            if (xhr.status === 200)
            {
                try
                {
                    res = JSON.parse(e.target.response);
                }
                catch (ex)
                {
                    resultEle.classList.remove("info");
                    resultEle.classList.add("error");
                    resultEle.innerText = "Unknown Error - failed to parse response from server, try again.";
                    ele.show(resultEle);
                    console.error("zip upload failed", ex);
                    this._files = null;
                }

                if (res.data.projectId)
                {
                    resultEle.classList.add("info");
                    resultEle.classList.remove("error");
                    resultEle.innerHTML = "Import successful! " + "<a href=\"/edit/" + res.data.projectId + "\">Open patch</a>";
                    ele.show(resultEle);
                    const optionsEle = ele.byId("importOptions");
                    if (optionsEle) ele.hide(optionsEle);
                    this._files = null;
                    setTimeout(() =>
                    {
                        button.innerText = "Import Zip";
                    }, 500);
                }
                else
                {
                    this._files = files;
                    if (res.data.problems && Object.keys(res.data.problems).length > 0)
                    {
                        const list = problemsEle.querySelector("ul");
                        list.innerText = "";
                        Object.values(res.data.problems).forEach((text) =>
                        {
                            const item = document.createElement("li");
                            item.innerHTML = text;
                            list.appendChild(item);
                        });
                        ele.show(problemsEle);
                        if (res.data.problems.import_multiple_projects && res.data.projectFiles)
                        {
                            res.data.projectFiles.forEach((projectFile) =>
                            {
                                const option = document.createElement("option");
                                option.setAttribute("value", projectFile);
                                option.innerText = projectFile;
                                filePicker.appendChild(option);
                            });
                            ele.show(filePicker);
                        }
                        else
                        {
                            this._files = null;
                        }
                    }
                    else
                    {
                        setTimeout(() =>
                        {
                            button.classList.add("button-primary");
                            button.innerText = "OK, Import!";
                        }, 500);
                    }
                }
            }
            else
            {
                this._files = null;
                resultEle.classList.remove("info");
                resultEle.classList.add("error");
                resultEle.innerText = res.msg;
                ele.show(resultEle);
            }
        };

        web.buttons.startSavingAnimButton(button, "importing...");
        xhr.send(formData);
    }
}
